/**
 * Mainbeauty — đóng/mở mượt cho <details data-pi-collapse> (CSS ở _mainbt-collapse.scss).
 */
$(function () {
	document.querySelectorAll("details[data-pi-collapse]").forEach(function (item) {
		const summary = item.querySelector("summary");
		if (!summary || item.dataset.piCollapseReady) {
			return;
		}
		item.dataset.piCollapseReady = "1";

		// Chuyển mọi node sau <summary> vào lớp bọc thì mới animate được.
		const body = document.createElement("div");
		body.className = "pi-collapse__body";
		const inner = document.createElement("div");
		inner.className = "pi-collapse__inner";
		let node = summary.nextSibling;
		while (node) {
			const next = node.nextSibling;
			inner.appendChild(node);
			node = next;
		}
		body.appendChild(inner);
		item.appendChild(body);

		item.classList.add("pi-collapse");
		if (item.open) {
			item.classList.add("pi-collapse--open");
		}

		summary.addEventListener("click", function (e) {
			// Link trong summary (Học thử miễn phí) vẫn điều hướng bình thường.
			if (e.target.closest("a")) {
				return;
			}
			e.preventDefault();
			// Badge khóa mở popup đăng ký (mainbt-video.js), accordion đứng yên.
			if (e.target.closest("[data-pi-lock]")) {
				return;
			}
			if (item.dataset.animating) {
				return;
			}

			if (item.classList.contains("pi-collapse--open")) {
				// Thu lại: mờ + xẹp xong mới bỏ open, giữ nội dung hiển thị lúc animate.
				item.dataset.animating = "1";
				item.classList.remove("pi-collapse--open");
				body.addEventListener(
					"transitionend",
					function done(ev) {
						if (ev.propertyName !== "grid-template-rows") {
							return;
						}
						item.open = false;
						delete item.dataset.animating;
					},
					{ once: true }
				);
			} else {
				// Bung: render nội dung, ép reflow rồi mới animate.
				item.open = true;
				void body.offsetHeight;
				item.classList.add("pi-collapse--open");
			}
		});
	});
});
